

<main fxLayout="column" fxLayoutAlign="flex-start center">

  <img src="assets/img/logo-plvbroker.svg" alt="" *ngIf="window.location.href.includes('digitalbroker')">

  <mat-card fxLayout="column" fxLayoutAlign="space-around center">

    <section>
      <h1>{{ 'connect' | translation }}</h1>
      <p>{{'accessBO' | translation}}</p>

    </section>


    <form fxLayout="column" fxLayoutAlign="center center">
      <mat-form-field>
        <input matInput [placeholder]="'email' | translation" [(ngModel)]="login" [ngModelOptions]="{standalone: true}">
      </mat-form-field>

      <mat-form-field>
        <input type="password" matInput [placeholder]="'password'| translation" [(ngModel)]="password" [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </form>


    <button mat-raised-button color="accent" (click)="log()">{{'connectUser' | translation}}</button>
    <div (click)="triggerResetPassword()">
      <p *ngIf="window.location.href.includes('digitalbroker') || window.location.href.includes('localhost')"><strong>Mot de passe oublié ?</strong></p>
    </div>
    <p>
      {{'needHelp' | translation}} <br> {{'savContact' | translation}}
      <a *ngIf="window.location.href.includes('digitalbroker') || window.location.href.includes('localhost')" href="mailto:dev@plv-broker.com">dev@plv-broker.com</a>
      <a *ngIf="window.location.href.includes('id2son')" href="mailto:sav@id2son.fr">sav@id2son.fr</a>
      <a *ngIf="window.location.href.includes('absolute-event')" href="mailto:info@absolute-event.com">info@absolute-event.com</a>
    </p>



  </mat-card>









</main>




